import React from 'react';
import ReactDOM from 'react-dom/client';

import { initAnalytics } from '@/services/monitoring/analytics';

import { App } from './App';
import '@/styles/globals.css';
import 'maplibre-gl/dist/maplibre-gl.css';

// Initialize global debug flag from localStorage
try {
  window.NABAT_DEBUG = localStorage.getItem('NABAT_DEBUG') === 'true';
} catch {
  window.NABAT_DEBUG = false;
}

initAnalytics();

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element not found');

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
